<template>
  <div class="cooperation">
    <div class="trademark clearfix">
      <div class="school_title">产学研合作高等院校</div>
      <div  class="school_content" style="margin-bottom: 30px;justify-content:start;">
        <div class="school_img">
          <el-image src="../../../static/image/hzimg/njdx.jpg" class="image"></el-image>              
        </div>
        <div class="school_img">    
          <el-image src="../../../static/image/hzimg/xmdx.jpg" class="image"></el-image>       
        </div>       
        <div class="school_img">    
          <el-image src="../../../static/image/hzimg/hnsf.png" class="image"></el-image>       
        </div>
        <div class="school_img" style="width:250px;">    
          <el-image src="../../../static/image/hzimg/njgy.jpg" class="image"></el-image>       
        </div>
      </div>     
      <div class="school_title">战略合作伙伴</div>

      <div  class="school_content">
        <div class="school_img">
          <el-image src="../../../static/image/hzimg/shshi.jpg" class="image"></el-image>              
        </div>
        <div class="school_img">    
          <el-image src="../../../static/image/hzimg/mdsw.jpg" class="image"></el-image>       
        </div>
        <div class="school_img">    
          <el-image src="../../../static/image/hzimg/xinchanye.jpg" class="image"></el-image>       
        </div>
        <div class="school_img" style="width:250px;">    
          <el-image src="../../../static/image/hzimg/mairui.jpg" class="image"></el-image>       
        </div>
        <div class="school_img" style="width:250px;">    
          <el-image src="../../../static/image/hzimg/roche.jpg" class="image"></el-image>       
        </div>
        <div class="school_img" style="width:250px;">    
          <el-image src="../../../static/image/hzimg/sjk.jpg" class="image"></el-image>       
        </div>
        <div class="school_img" style="width:250px;">    
          <el-image src="../../../static/image/hzimg/fuxing.jpg" class="image"></el-image>       
        </div>
        <div class="school_img" style="width:250px;">    
          <el-image src="../../../static/image/hzimg/bcr.jpg" class="image"></el-image>       
        </div>
        <div class="school_img" style="width:250px;">    
          <el-image src="../../../static/image/hzimg/heszz.jpg" class="image"></el-image>       
        </div>
        <div class="school_img" style="width:250px;">    
          <el-image src="../../../static/image/hzimg/glyy.jpg" class="image"></el-image>       
        </div>
        <div class="school_img">    
          <el-image src="../../../static/image/hzimg/dbzq.jpg" class="image"></el-image>       
        </div>
        <div class="school_img">    
          <el-image src="../../../static/image/hzimg/jssrm.jpg" class="image"></el-image>       
        </div>
        <div class="school_img">    
          <el-image src="../../../static/image/hzimg/yfyy.jpg" class="image"></el-image>       
        </div>
        <div class="school_img" style="width:250px;">    
          <el-image src="../../../static/image/hzimg/nndt.jpg" class="image"></el-image>       
        </div>
        <div class="school_img"  style="width:250px;">    
          <el-image src="../../../static/image/hzimg/tpybx.jpg" class="image"></el-image>       
        </div>
        <div class="school_img">    
          <el-image src="../../../static/image/hzimg/hhdx.jpg" class="image"></el-image>       
        </div>
        <div class="school_img">    
          <el-image src="../../../static/image/hzimg/zgpa.jpg" class="image"></el-image>       
        </div>
        <div class="school_img">    
          <el-image src="../../../static/image/hzimg/zgykdx.png" class="image"></el-image>       
        </div>
        <div class="school_img">    
          <el-image src="../../../static/image/hzimg/njysxy.jpg" class="image"></el-image>       
        </div>
        <div class="school_img">    
          <el-image src="../../../static/image/hzimg/nnht.jpg" class="image"></el-image>       
        </div>
        <div class="school_img">    
          <el-image src="../../../static/image/hzimg/nxdx.jpg" class="image"></el-image>       
        </div>
        <div class="school_img">    
          <el-image src="../../../static/image/hzimg/njlg.jpg" class="image"></el-image>       
        </div>
        <div class="school_img">    
          <el-image src="../../../static/image/hzimg/njggjt.jpg" class="image"></el-image>       
        </div>
        <div class="school_img">    
          <el-image src="../../../static/image/hzimg/njkq.jpg" class="image"></el-image>       
        </div>
        <div class="school_img" >    
          <el-image src="../../../static/image/hzimg/nfy2.png" class="image"></el-image>       
        </div>
        <div class="school_img" style="opacity: 0;"></div>
        <div class="school_img" style="opacity: 0;"></div>
      </div>
      <!-- <div
        class="trademark_content"
        v-for="(item, key) in trademarkArr"
        :key="key"
      >
        <div class="trademark_item">
          <div class="imgBox">
            <img :src="item.src" alt="" style="width:130px;height:auto"/>
          </div>
          <div class="bottom">
            <p>{{ item.title }}</p>
          </div>
        </div>
      </div> -->
    </div>
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      trademarkArr: [
        { src: '../../../static/image/hysfdx.png', title: '湖南师范大学医学院' },
        { src: '../../../static/image/jsjk.png', title: '江苏省疾控' },
        { src: '../../../static/image/jskq.png', title: '江苏省口腔' },
        { src: '../../../static/image/sssw.png', title: '硕世生物' },
        { src: '../../../static/image/yfyy.png', title: '逸夫医院' },
        // { src: '../../../static/image/ygbx.png', title: '阳光保险集团' },
        { src: '../../../static/image/szdx.png', title: '中国人民解放军东部战区总医院' },
        // { src: '../../../static/image/tpybx.png', title: '太平洋保险' },
        // { src: '../../../static/image/zgrs.png', title: '中国人寿' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.cooperation {
  padding-top: 30px;
  .trademark {
    padding: 0 7% 0 8%;
    margin-bottom: 62px;
    .school_title{
      font-size: 20px;
      margin-bottom: 20px;
      font-weight: bold;
      color: #0068b7;
    }
    .school_content{
      width: 100%;
      min-height: 200px;
      // border: 1px solid red;
      display: flex;
      justify-content:space-between;
      flex-wrap: wrap;
      .school_img{
        background-color: #fff;
        padding: 10px;
        width: 150px;
        height: 150px;
        margin-right: 20px;
        margin-bottom: 20px;
        
       .image{
        width: 100%;
        height: 100%;
       }
      }

    }
    // display: flex;
    // flex-wrap: wrap;
    // .trademark_content {
    //   float: left;
    //   width: 16.6%;
    //   height: 16.6%;
    //   margin-bottom: 28px;
    //   .trademark_item {
    //     width: 90%;
    //     background-color: #c1daea;
    //     text-align: center;
    //     .imgBox {
    //       width: 100%;
    //       height: 160px;
    //       position: relative;
    //       padding-bottom: 0;
    //       img {
    //         position: absolute;
    //         top: 50%;
    //         left: 50%;
    //         transform: translate(-50%, -50%);
    //       }
    //     }
    //     .bottom {
    //       width: 100%;
    //       height: 40px;
    //       line-height: 40px;
    //       background-color: #60a1d0;
    //       p {
    //         color: #fff;
    //       }
    //     }
    //   }
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/website/aboutUs/component/cooperation.vue